import React from "react";
// import "../styles/Credits.css";
import FadeInSection from "./FadeInSection";
import "../styles/About.css";

class Team extends React.Component {
  constructor() {
    super();
    this.state = {
      expanded: true,
      activeKey: "1"
    };
    this.handleSelect = this.handleSelect.bind(this);
  }
  handleSelect(eventKey) {
    this.setState({
      activeKey: eventKey
    });
  }
  render() {
    return (
        <div id="about">
        <FadeInSection>
          <div className="section-header ">
            <span className="section-title">/meet the team</span>
          </div>
          <div className="about-content">
            <div className="about-description">
                <div className="about-image">
                    <div className="team-member">
                        <img alt="Samiya" src={"/assets/me.jpg"} />
                        <span>Samiya Islam</span>
                    </div>
                    <div className="team-member">
                        <img alt="Zen" src={"/assets/zen.jpeg"} />
                        <span>Zen Edwards</span>
                    </div>
                    <div className="team-member">
                        <img alt="Jameer" src={"/assets/jameer.jpg"} />
                        <span>Jameer Santos</span>
                    </div>
                </div>
            </div>  
        </div>

        </FadeInSection>
      </div>
    );
  }
}

export default Team;
